/**
 * Mixing to make a component uploadable
 * exposes and upload
 */

import { get, forEach } from 'lodash';
import axios from 'axios';
import { getUploadUrl, confirmUpload } from '@/api';

export default {
  data() {
    return {
      uploadDetails: {},
      hidden: 0,
    };
  },
  methods: {
    uploadMedia(file, params, hidden = 0) {
      this.hidden = hidden;
      this.uploadDetails.file = file;
      this.uploadDetails = {
        ...this.uploadDetails,
        ...params,
      };

      return Promise.resolve()
        .then(this.getUploadUrl)
        .then(this.uploadFile)
        .then(this.confirmUpload);
    },
    getUploadUrl() {
      // make the network call and get the s3 upload data
      return new Promise((resolve, reject) => {
        const userToken = this.$store.getters['auth/userToken'];
        const fileKey = this.uploadDetails.file.name;
        getUploadUrl(userToken, fileKey, this.hidden)
          .then(({ data }) => {
            const status = get(data, '[1].status');
            if (status === 'SUCCESS') {
              this.uploadDetails = {
                ...this.uploadDetails,
                ...get(data, '[1].data.details'),
              };
              resolve();
            } else {
              reject();
            }
          })
          .catch(reject);
      });
    },
    uploadFile() {
      return new Promise((resolve, reject) => {
        const url = `${this.uploadDetails.s3_data.url}`;
        const params = this.uploadDetails.s3_data.inputs;
        params['Content-Type'] = this.uploadDetails.file.type;
        params.file = this.uploadDetails.file;

        // convert data to form data
        const formData = new FormData();
        formData.append('key', this.uploadDetails.s3_data.key);
        forEach(params, (value, key) => {
          formData.append(key, value);
        });

        axios.post(url, formData).then(resolve).catch(reject);
      });
    },
    confirmUpload() {
      // use the final obj url and let the server know that the upload was successful
      return new Promise((resolve, reject) => {
        const userToken = this.$store.getters['auth/userToken'];
        confirmUpload(userToken, this.uploadDetails, this.hidden)
          .then(() => {
            const mediaObject = this.uploadDetails;
            mediaObject.data_url = `${this.uploadDetails.s3_data.url}/${this.uploadDetails.s3_data.key}`;
            resolve(mediaObject);
          })
          .catch(reject);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/uploader.js